import React from 'react';
import { useInput } from '../InputContext';
import * as S from './styles';
import { InputAdornmentProps, InputAdornmentStyleProps } from './types';

const InputAdornment: React.FC<InputAdornmentProps> = ({
  children,
  className,
  position,
  ...ariaAttributes
}) => {
  const { validationState } = useInput();

  const styleProps: InputAdornmentStyleProps = {
    $position: position,
    $validationState: validationState,
  };

  return (
    <S.InputAdornmentRoot
      className={className}
      {...styleProps}
      {...ariaAttributes}
    >
      {children}
    </S.InputAdornmentRoot>
  );
};

export default InputAdornment;
